import React from 'react';
type BaseProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'violet' | 'green';
};
type ButtonAsButton = BaseProps & React.ButtonHTMLAttributes<HTMLButtonElement> & {
  href?: undefined;
};
type ButtonAsLink = BaseProps & React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  href: string;
};
type ButtonProps = ButtonAsButton | ButtonAsLink;
const VARIANTS = {
  violet: 'bg-violet-600 hover:bg-violet-700 text-white shadow-[0_4px_0_0_rgba(109,40,217,1)]',
  green: 'bg-green-500 hover:bg-green-600 text-white shadow-[0_4px_0_0_rgba(21,128,61,1)]'
};
export function Button({
  children,
  className = '',
  variant = 'violet',
  ...props
}: ButtonProps) {
  const base = `w-full font-bold py-4 px-6 rounded-xl active:shadow-none active:translate-y-1 transition-all flex flex-col items-center justify-center gap-1 ${VARIANTS[variant]} ${className}`;
  if ('href' in props && props.href) {
    return <a className={base} {...props as React.AnchorHTMLAttributes<HTMLAnchorElement>} data-id="element-198">
        {children}
      </a>;
  }
  return <button className={base} {...props as React.ButtonHTMLAttributes<HTMLButtonElement>} data-id="element-199">
      {children}
    </button>;
}